import React, { useState } from 'react'
import { useGetGoals } from '../../../redux/human-resources/hook/performance'
import AddGoal from './goals-process/AddGoal'
import Button from '../../../components/button'
import { PAGINATION_DEFAULT } from '../../../utils/constants'
import DataTable from '../../../components/datatable'

const HrGoals = () => {
  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    search: '',
  })
  const [goals, setGoals] = useState(false)

  const {
    data: employeeGoals,
    refetch: refetchGoals,
  } = useGetGoals(pagination?.limit, pagination?.page, pagination?.search)

  const tableConfig = {
    headers: ['Goal Name', 'Start Date', 'Target Date'],
    keys: ['name', 'start_date', 'target_date'],
    mobileHeader: {
      left: {
        title: 'Goal Name',
        key: 'name',
      },
      right: {
        title: 'Start Date',
        key: 'start_date',
      },
    },
  }
  return (
    <section className='bg-white p-3 flex flex-col'>
      {goals ? (
        <AddGoal
          isOpen={goals}
          closeModal={() => setGoals(false)}
          type={1}
          refetchGoals={refetchGoals}
        />
      ) : null}

      <main className='flex flex-col  my-4 md:flex-row justify-between items-start md:items-center gap-[10px]'>
        <div className='flex flex-col gap-1 items-start '>
          <h1 className='text-[20px] font-bold'>Employee Goals</h1>
          <p className='text-sm font-medium'>
            Create goals for your employees for seamless collaboration
          </p>
        </div>

        <div className='w-fit'>
          <Button
            text='Add New Goal'
            type='button'
            theme='primary'
            className='flex gap-2 !h-[35px] md:w-fit w-full px-2 items-center'
            textClass={'!text-[11px]'}
            leftIcon={'add'}
            onClick={() => setGoals(true)}
          />
        </div>
      </main>
      <DataTable
        data={employeeGoals}
        tableConfig={tableConfig}
        // actionConfig={actionConfig}
        updatePagination={(data) => setPagination(data)}
        // computedActions={true}
        tableType={'goals'}
        searchData={true}
      />
    </section>
  )
}

export default HrGoals
